import React, { useEffect, useState } from "react";
import {
  Card, CardBody, CardTitle, Col, Container, Row, Table, Spinner, Button, Modal, ModalHeader, ModalBody, Form, Label, Input
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import MiniCards from "./mini-card";
import ApexRevenue from "../ApexRevenue";
import { ToastContainer, toast } from "react-toastify";
import profile1 from "assets/images/profile-img.png";

const KurumsalProfil = () => {
  document.title = "Kurumsal Bilgiler | LojGo Admin";

  const [systemData, setSystemData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  // Admin Kontrolü
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const isAdmin = authUser?.Users_Type_ID === 3;

  const toggleModal = () => setModal(!modal);

  // 1. Veritabanından System_About verilerini çek (Tek satırlık ID:1 varsayıyoruz)
  const fetchSystemInfo = async () => {
    setIsLoading(true);
    try {
      const response = await fetch("https://hiflowapi.stechomeyazilim.info/System_About(1)");
      const result = await response.json();
      if (result) {
        setSystemData(result);
      }
    } catch (error) {
      toast.error("Kurumsal bilgiler yüklenemedi.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isAdmin) fetchSystemInfo();
  }, [isAdmin]);

  // 2. Güncelleme İşlemi (PUT)
  const handleUpdate = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    try {
      const response = await fetch("https://hiflowapi.stechomeyazilim.info/System_About(1)", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(systemData)
      });
      if (response.ok) {
        toast.success("Kurumsal bilgiler güncellendi.");
        setModal(false);
      }
    } catch (error) {
      toast.error("Güncelleme sırasında hata oluştu.");
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) return <div className="text-center py-5"><Spinner color="primary" /></div>;

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Sistem" breadcrumbItem="Kurumsal Profil" />

          <Row>
            <Col xl="4">
              {/* HOŞGELDİN KARTI */}
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle text-primary p-3">
                  <h5>LojGo Yönetim</h5>
                  <p className="mb-0">Kurumsal Kimlik Ayarları</p>
                </div>
                <CardBody className="pt-0">
                  <div className="text-center mt-n4">
                    <div className="avatar-md mx-auto mb-3">
                        <span className="avatar-title rounded-circle bg-light shadow-sm">
                            <img src={profile1} alt="" height="30" />
                        </span>
                    </div>
                    <h5 className="font-size-16">{systemData?.Company_Title}</h5>
                    <p className="text-muted">Resmi Ünvan</p>
                  </div>
                </CardBody>
              </Card>

              {/* SYSTEM_ABOUT TABLOSUNDAN GELEN VERİLER */}
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <CardTitle className="mb-0 text-primary">Yasal Bilgiler</CardTitle>
                    <Button color="soft-primary" size="sm" onClick={toggleModal}>
                        <i className="bx bx-edit-alt"></i> Düzenle
                    </Button>
                  </div>
                  <div className="table-responsive">
                    <Table className="table-nowrap mb-0 table-sm">
                      <tbody>
                        <tr><th scope="row">Vergi No :</th><td>{systemData?.Tax_Number}</td></tr>
                        <tr><th scope="row">Vergi Dairesi :</th><td>{systemData?.Tax_Office}</td></tr>
                        <tr><th scope="row">E-posta :</th><td>{systemData?.Contact_Email}</td></tr>
                        <tr><th scope="row">Web :</th><td>{systemData?.Website_Url}</td></tr>
                        <tr><th scope="row">Adres :</th><td className="text-wrap">{systemData?.Official_Address}</td></tr>
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col xl="8">
              <Row>
                <Col md={4}><Card className="mini-stats-wid"><CardBody className="d-flex align-items-center">
                    <div className="flex-grow-1"><p className="text-muted fw-medium">Sistem Durumu</p><h4 className="mb-0 text-success">Çevrimiçi</h4></div>
                    <div className="avatar-sm"><span className="avatar-title rounded-circle bg-success"><i className="bx bx-server font-size-24"></i></span></div>
                </CardBody></Card></Col>
              </Row>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">Finansal Akış Özeti</CardTitle>
                  <ApexRevenue dataColors='["--bs-primary"]' />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* --- GÜNCELLEME MODALI --- */}
      <Modal isOpen={modal} toggle={toggleModal} centered>
        <ModalHeader toggle={toggleModal}>Kurumsal Bilgileri Güncelle</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleUpdate}>
            <div className="mb-3">
                <Label>Şirket Ünvanı</Label>
                <Input value={systemData?.Company_Title} onChange={(e) => setSystemData({...systemData, Company_Title: e.target.value})} />
            </div>
            <Row>
                <Col md={6} className="mb-3">
                    <Label>Vergi No</Label>
                    <Input value={systemData?.Tax_Number} onChange={(e) => setSystemData({...systemData, Tax_Number: e.target.value})} />
                </Col>
                <Col md={6} className="mb-3">
                    <Label>Vergi Dairesi</Label>
                    <Input value={systemData?.Tax_Office} onChange={(e) => setSystemData({...systemData, Tax_Office: e.target.value})} />
                </Col>
            </Row>
            <div className="mb-3">
                <Label>Resmi Adres</Label>
                <Input type="textarea" value={systemData?.Official_Address} onChange={(e) => setSystemData({...systemData, Official_Address: e.target.value})} />
            </div>
            <div className="text-end mt-3">
                <Button color="primary" type="submit" disabled={isSaving}>{isSaving ? "Kaydediliyor..." : "Değişiklikleri Kaydet"}</Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
      <ToastContainer />
    </React.Fragment>
  );
};

export default KurumsalProfil;